import { Component, OnInit } from '@angular/core';
import { MasterFormComponent } from '../../form/master-form/master-form.component';
@Component({
  selector: 'app-master-detail',
  templateUrl: './master-detail.component.html',
  styles: []
})
export class MasterDetailComponent extends MasterFormComponent {

 

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/detail/master-detail/master-detail.component.ts